export default __webpack_public_path__ + "static/audi-iconfont-face5381b8c96b26d9369e790d8987b5.svg";